// extracted by mini-css-extract-plugin
export default {"footer":"ui_footer__lqOC7","content":"ui_content__G3SKk","results":"ui_results__sGOXS"};